import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import messages from 'aurora-translations';
import { ADGMModal, ADGMImage } from 'aurora-components';

import styles from './styles';

function InformationModal(props) {
  const { classes, open, toggleModal, proced } = props;

  return (
    <ADGMModal open={open} toggleModal={toggleModal} className={classes.confirmationModal}>
      <div className={classes.titleContainer}>
        <Typography component='p'>
          <FormattedMessage {...messages.late_registration_fine} />{' '}
        </Typography>
        <ADGMImage name='cross.svg' alt='cross' onClick={toggleModal} aria-hidden='true' />
      </div>
      <div className={classes.content}>
        <Typography component='p'>
          <FormattedMessage {...messages.off_plan_selling_date_of_sale_note} />
        </Typography>
      </div>
      <div className={classes.buttonContainer}>
        <Button onClick={proced}>
          <FormattedMessage {...messages.proceed} />
        </Button>
      </div>
    </ADGMModal>
  );
}

InformationModal.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  proced: PropTypes.func.isRequired,
};

export default withStyles(styles)(InformationModal);
